import React, { ReactElement } from 'react'
import Spinner from '../components/Spinner'
import { WelcomeTemplate } from './templates'
import useLoginHook from '../hooks/useLoginHook'
import kycCore from '../services/Kyc'
import TwoFactorAuth from './TwoFactorAuth'

function Welcome(): ReactElement {
  const { auth } = kycCore
  auth.logout()
  document.title = 'Louvre Banque Privée - Me connecter'
  const { isCheckingToken, phoneNumber } = useLoginHook()

  if (isCheckingToken) {
    return (
      <WelcomeTemplate>
        <div className="colLg7 offsetLg2 orderLg1">
          <div className="card cardContent px15 px6md  mb3 mb5md mb0md">
            <div className="relative pt5 pb5">
              <Spinner small={true} />
            </div>
          </div>
        </div>
      </WelcomeTemplate>
    )
  }

  return <TwoFactorAuth phoneNumber={phoneNumber} />
}

export default Welcome
